import { render, staticRenderFns } from "./AddPurchaseReturn.vue?vue&type=template&id=5198d037&"
import script from "./AddPurchaseReturn.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5198d037')) {
      api.createRecord('5198d037', component.options)
    } else {
      api.reload('5198d037', component.options)
    }
    module.hot.accept("./AddPurchaseReturn.vue?vue&type=template&id=5198d037&", function () {
      api.rerender('5198d037', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/AddPurchaseReturn.vue"
export default component.exports